import { useTranslation } from 'react-i18next';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import type { BilingualStringIndex } from 'types/BilingualStringIndex';

export function useCurrentLanguage() {
  const { i18n } = useTranslation();

  return (i18n.resolvedLanguage || i18n.languages[0]).toUpperCase() as BilingualStringIndex;
}
